import emailjs from '@emailjs/browser';

// Initialize EmailJS with your public key
export function initEmailJS() {
  emailjs.init(import.meta.env.VITE_EMAILJS_PUBLIC_KEY);
}